
import * as export0 from "/opt/build/repo/functions/posterGenerator/index.js";

export default {
  "posterGenerator": export0
};
